<template>
  <v-row justify="end" class="mr-0">
    <v-dialog persistent v-model="changeCashDialog" max-width="400px">
      <v-card>
        <v-card-title color="White">
          <span class="headline">Ažuriraj keš</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-on:submit.prevent>
            <v-text-field
              :rules="rules.required_number"
              label="Keš"
              v-model="form.cashData"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="white" align="right">
          <div class="flex-grow-1"></div>
          <v-btn class="mr-4" text color="primary" dark @click="closeDialog(-1)">
            {{$t('close')}}
          </v-btn>
          <v-btn class="mr-4" text color="primary" :loading="loading" dark @click="add()">
            {{$t('confirm')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import {
    addEmit,
    editEmit,
    findById,
    onDelete, readPartnersActive,
    readTableData,
    readTableDataById,
    refresh,
    search
  } from "../../statics/DataTableFunctions";
  import axios from "axios";

  export default {
    props: {
      cash: '',
      changeCashDialog: false,
      camapign_id: '',
      partner_id: '',
    },
    name: 'ChangeCashDialog',
    data() {
      return {
        form: {
          cashData: ''
        },
        loading: false,
        rules: {
          required_number: [value => {
            const pattern = /^[0-9]\d{0,9}(\.\d{1,3})?%?$/
            return pattern.test(value) || 'Ovo polje mora biti broj.'
          }]
        },
      }
    },
    methods: {
      add() {
        if (!this.$refs.form.validate()) {
          this.snackbar.color = 'error';
          this.snackbar.text = 'Nijeste popunili polje';
          this.snackbar.show = true;
          return;
        }
        this.loading = true;
        axios.post('api/partnerCampaignsCash/' + this.camapign_id, {cash: this.form.cashData, partner_id: this.partner_id}).then(response => {
          this.$emit('editEmit', response.data);
          this.loading = false;
          this.closeDialog();
        }).catch(error => {
          this.loading = false;
          if (error.response.status == 401) {
            this.loading = false
            this.$swal.fire({
              type: 'info',
              title: "Info",
              text: this.$t('validation.session'),
            })
            this.$router.push('/login')
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: this.$t('validation.error'),
            })
          }
        })
      },
      closeDialog() {
        this.$refs.form.resetValidation()
        this.$emit('close');
      },
    },
    watch: {
      changeCashDialog: function (val) {
        if (val) {
          this.form = {
            cashData: this.cash,
          }
        }
      },
    },
  }
</script>

<style scoped/>
